<template>
    <el-dialog title="评价" :visible.sync="evaluateDialogVisible" width="500px">
        <div class="evaluateDialogBox">
            <div class="evaluateItem">
                <div class="name">评价等级</div>
                <div class="content">
                    <div class="rateItem">
                        <div class="name">描述相符</div>
                        <el-rate
                            v-model="evaluateForm.descriptionPoint"
                            show-score
                            text-color="#ff9900"
                        >
                        </el-rate>
                    </div>
                    <div class="rateItem">
                        <div class="name">服务态度</div>
                        <el-rate
                            v-model="evaluateForm.servicePoint"
                            show-score
                            text-color="#ff9900"
                        >
                        </el-rate>
                    </div>
                    <div class="rateItem">
                        <div class="name">专业程度</div>
                        <el-rate
                            v-model="evaluateForm.transportPoint"
                            show-score
                            text-color="#ff9900"
                        >
                        </el-rate>
                    </div>
                </div>
            </div>
            <div class="evaluateItem">
                <div class="name">评价标签</div>
                <div class="content">
                    <el-checkbox-group
                        v-model="evaluateForm.evaluationTagList"
                        class="evaluateTag"
                    >
                        <el-checkbox-button
                            v-for="tag in tagList"
                            :label="tag"
                            :key="tag.tagUuid"
                        >{{ tag.tagName }}</el-checkbox-button
                        >
                    </el-checkbox-group>
                </div>
            </div>
            <div class="evaluateItem">
                <div class="name">评价内容</div>
                <div class="content">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 6 }"
                        placeholder="请输入内容"
                        v-model="evaluateForm.evaluationContent"
                    >
                    </el-input>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
                <el-button @click="evaluateDialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="stepLoading" @click="evaluateSubmit">确 定</el-button>
            </span>
    </el-dialog>
</template>

<script>
    import { saveEvaluation,getDictionaryItem } from '../../../utils/interface';
    export default {
        name: "cancelOrder",
        data(){
            return{
                stepLoading: false,
                // 评价
                evaluateDialogVisible: false,
                evaluateForm: {
                    descriptionPoint: 0,
                    servicePoint: 0,
                    transportPoint: 0,
                    evaluationTagList: [],
                    evaluationContent: "",
                },
                tagList: [],
                order:"",
            }
        },
        methods: {
            init(printOrderInfo){
                this.order = printOrderInfo;
                getDictionaryItem({groupCode: "print_evaluation_tag"}).then((res) => {
                    this.tagList = [];
                    res.forEach((item, index) => {
                        this.tagList.push({tagName: item.name, tagUuid: item.code, tagGroupId: item.groupUuid});
                    });
                });
                this.evaluateForm = {
                    descriptionPoint: 0,
                    servicePoint: 0,
                    transportPoint: 0,
                    evaluationTagList: [],
                    evaluationContent: "",
                };
                this.evaluateDialogVisible = true;
            },
            evaluateSubmit(){
                this.stepLoading = true;
                if (
                    this.evaluateForm.descriptionPoint &&
                    this.evaluateForm.servicePoint &&
                    this.evaluateForm.transportPoint
                ) {
                    this.evaluateForm.orderNo = this.order.orderBase.orderNo;
                    this.evaluateForm.orderUuid = this.order.uuid;
                    this.evaluateForm.orderType = 'PRINT';
                    this.evaluateForm.evaluationType = 'NORMAL';
                    this.evaluateForm.sellerName = this.order.enterPriseName;
                    this.evaluateForm.sellerUuid = this.order.enterPriseId;
                    if(this.order.list.length > 0){
                        this.evaluateForm.orderName = this.order.list[0].name;
                    }
                    this.evaluateForm.orderAmount = this.order.orderBase.totalPrice == null ? 0 : this.order.orderBase.totalPrice;

                    saveEvaluation(this.evaluateForm).then((response) => {
                        if (response.success) {
                            this.evaluateDialogVisible = false;
                            this.$message({
                                type: "success",
                                message: "评价成功",
                            });
                            this.$emit('evaluateOrderSuccess');
                        } else {
                            this.$message({
                                type: "error",
                                message: response.message,
                            });
                        }
                    });
                } else {
                    this.$message.warning("请选择评价等级");
                }
                setTimeout(() => {
                    this.stepLoading = false;
                }, 1000);
            },
        }
    }
</script>

<style scoped lang="less">
    .addressDialog{
        /deep/.el-dialog__header{
            border-bottom: 1px solid #ddd;
        }
        /deep/.el-dialog__body{
            padding: 0;
        }
        .submitButtonGroup{
            text-align: right;
            margin-bottom: 0;
            border-top: 1px solid #ddd;
            padding: 10px 30px;
        }
    }
    .addressList{
        padding: 24px 30px 20px;
        display: flex;
        flex-wrap: wrap;
        .addressItem{
            padding: 14px 22px;
            margin-bottom: 24px;
            margin-right: 30px;
            position: relative;
            width: 270px;
            border-radius: 8px;
            border: 2px dashed #E3E3E3;
            font-size: 14px;
            .addressBorder{
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
            }
            &.active{
                border: 2px dashed #fff;
            }
            &:nth-of-type(4n){
                margin-right: 0;
            }
            .checkBox{
                position: absolute;
                right: 22px;
                top: 14px;
            }
            .name{
                color: #000;
            }
            .tel{
                color: rgba(51, 51, 51, 0.85);
                padding: 6px 0;
            }
            .address{
                color: rgba(51, 51, 51, 0.85);
                line-height: 22px;
            }
        }
        .addItem{
            text-align: center;
            cursor: pointer;
            color: #666;
            &:hover{
                border: 2px dashed #1890FF;
            }
            .icon{
                font-size: 30px;
            }
            .addName{
                font-size: 14px;
                padding-top: 5px;
            }
        }
    }
        .evaluateDialogBox {
        .evaluateItem {
            .name {
                font-size: 14px;
                color: #000;
                padding-bottom: 20px;
                font-weight: bold;
            }

            .content {
                padding-left: 20px;
                padding-bottom: 15px;
            }

            .rateItem {
                display: flex;
                align-items: center;
                padding-bottom: 15px;

                .name {
                    padding: 0 20px 0 0;
                    font-size: 13px;
                    color: #333;
                    min-width: 100px;
                    font-weight: normal;
                }
            }

            .evaluateTag {
                display: flex;
                flex-wrap: wrap;

                /deep/ .el-checkbox-button {
                    display: block;
                    margin-right: 20px;
                    margin-bottom: 15px;

                }

                /deep/ .el-checkbox-button__inner {
                    border: 1px solid #DCDFE6 !important;
                    border-radius: 4px;
                    padding: 8px 15px;
                    font-size: 13px;
                    box-shadow: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/evaluateOrder.vue